import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 查询所有省份
export function getAllProvince() {
  return request({
    url: apiConfig.cityCode.api.getAllProvince.url,
    method: "get"
  });
}

// 查询所有城市
export function getAllCity() {
  return request({
    url: apiConfig.cityCode.api.getAllCity.url,
    method: "get"
  });
}

// 根据省份查询城市
export function getCityByProvince(req) {
  return request({
    url: apiConfig.cityCode.api.getCityByProvince.url,
    method: "get",
    params: {
      provinceCode: req
    }
  });
}

// 根据城市查询地区
export function getAreaListByCity(req) {
  return request({
    url: apiConfig.cityCode.api.getAreaListByCity.url,
    method: "get",
    params: {
      cityCode: req
    }
  });
}
export function getCityByAreaCode(req) {
  return request({
    url: apiConfig.cityCode.api.getCityByAreaCode.url,
    method: "get",
    params: {
      cityCode: req
    }
  });
}
